// src/components/Task.js
import { useState } from "react";
import "../../../styles/Task.css";
import Toast from "../../../utils/Toast";
import AuthHandler from "../../../utils/AuthHandler";
import Axios from "../../../utils/Axios";
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { DELETE_TASK } from "../../../config/API_Collection";
import TaskAllocationModal from "./TaskAllocationModel";
import { useSelector } from "react-redux";
import ActionModal from "../ActionModal";
import EditBudget from "../Budgets/EditBudget";
import AddTask from "./AddTask";
import EditTask from "./EditTask";
import TaskItem from "./TaskItem";

function Task({ data, refreshProjectData, update, setUpdate }) {
  const navigate = useNavigate();

  const [toast, setToast] = useState({ message: "", type: "" });


  // shared date state per active modal (task add/edit)

  const [selectedBudget, setSelectedBudget] = useState(null);

  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [showModalRemove, setShowModalRemove] = useState(false);
  const [showModalTAllocation, setShowModalTAllocation] = useState(false);

  // Edit Budget modal
  const [showModalEditBudget, setShowModalEditBudget] = useState(false);
  const [budgetEdit, setBudgetEdit] = useState({
    budget_id: "",
    budget_name: "",
    budget_type: "", // "expences" | "time"
    allocated_amount: "",
  });

  const [taskAssign, setTaskAssign] = useState([]);
  const [selectedTaskIdRemove, setSelectedTaskIdRemove] = useState(null);

  const login = useSelector((s) => s?.login);
  const actions = login?.actions || null;
  const canAddTask = actions?.tasks?.add_task === true;
  const canEditTask = actions?.tasks?.edit_task === true;
  const canDeleteTask = actions?.tasks?.delete_task;
  const canEditBudget = actions?.budgets?.edit_budget;

  const [editData, setEditData] = useState({
    budget_id: "",
    task_id: "",
    task_name: "",
    task_type: "",
    start_date: "",
    end_date: "",
  });

  const budgets = data?.budget_data || [];

  const showToast = (message, type) => setToast({ message, type });

  // ---- Open/Close modals (Task) ----
  const OpenModalAdd = (bid) => {
    setSelectedBudget(bid ?? "");

    setShowModalAdd(true);
  };
  const CloseModalAdd = () => setShowModalAdd(false);

  const OpenModalEdit = (
    task_id,
    bid,
    task_name,
    task_type,
    startDate,
    endDate
  ) => {
    setEditData({
      budget_id: bid ?? "",
      task_id: task_id ?? "",
      task_name: task_name || "",
      task_type: task_type || "",
      start_date: startDate || "",
      end_date: endDate || "",
    });
    setShowModalEdit(true);
  };
  const CloseModalEdit = () => setShowModalEdit(false);

  const OpenModalRemove = (tid) => {
    setSelectedTaskIdRemove(tid);
    setShowModalRemove(true);
  };
  const CloseModalRemove = () => setShowModalRemove(false);

  const OpenModalTAllocation = (task) => {
    setTaskAssign(task);
    setShowModalTAllocation(true);
  };
  const handleCloseModalAllocation = () => setShowModalTAllocation(false);

  // ---- Edit Budget modal open/close ----
  const OnEditBudget = (budget) => {

    const existingAmount =
      budget?.allocated_amount ?? budget?.budget ?? budget?.amount ?? "";

    setBudgetEdit({
      budget_id: budget?.bid ?? "",
      budget_name: budget?.budget_name ?? "",
      budget_type: budget?.budget_type,
      allocated_amount:
        existingAmount !== null && existingAmount !== undefined
          ? String(existingAmount)
          : "",
    });
    setShowModalEditBudget(true);
  };
  const CloseModalEditBudget = () => setShowModalEditBudget(false);

  const handleRemoveTask = async () => {
    try {
      const response = await Axios.post(DELETE_TASK, {
        task_id: selectedTaskIdRemove,
      });
      if (response.status === 200) {
        showToast("Task Deleted Successfully!", "success");
        CloseModalRemove();
      }
    } catch (error) {
      AuthHandler(error.response?.status, setToast, navigate);
    } finally {
      refreshProjectData();
    }
  };

  const loginState = useSelector((s) => s?.login);
  const actions2 = loginState?.actions || null;
  const canAddTask1 = actions2?.tasks?.add_task === true;

  return (
    <div className="fs-6">
      <Toast message={toast.message} type={toast.type} />

      <div className="row">
        <div className="col-12 col-md mb-4">
          <span className="budget-summery">Task Breakdown</span>
          <div className="card budget-card">
            <div className="card-body">
              {budgets.length > 0 ? (
                budgets.map((budget) => (
                  <TaskItem
                    key={budget.bid}
                    budget={budget}
                    canAddTask={canAddTask}
                    canEditBudget={canEditBudget}
                    canAddTask1={canAddTask1}
                    canEditTask={canEditTask}
                    canDeleteTask={canDeleteTask}
                    OpenModalAdd={OpenModalAdd}
                    OnEditBudget={OnEditBudget}
                    OpenModalTAllocation={OpenModalTAllocation}
                    OpenModalEdit={OpenModalEdit}
                    OpenModalRemove={OpenModalRemove}
                  />
                ))
              ) : (
                <div className="text-center">
                  <div className="no-content-msg">
                    <span>No Task Available</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Add Task Modal */}
      <ActionModal
        show={showModalAdd}
        title="Create New Task"
        size="lg"
        modalBody={
          <AddTask
            budgets={budgets}
            selectedBudget={selectedBudget}
            showToast={showToast}
            CloseModalAdd={CloseModalAdd}
            refreshProjectData={refreshProjectData}
            setToast={setToast}
          />
        }
      />

      {/* Edit Task Modal */}

      <ActionModal
        show={showModalEdit}
        title={"Update Task"}
        size="lg"
        modalBody={
          <EditTask
            budgets={budgets}
            editData={editData}
            setToast={setToast}
            showToast={showToast}
            CloseModalEdit={CloseModalEdit}
            refreshProjectData={refreshProjectData}
          />
        }
      />

      {/* Delete Task Modal */}

      <ActionModal
        show={showModalRemove}
        title="Confirm Task Deletion"
        confirmText="Yes"
        cancelText="No"
        onConfirm={handleRemoveTask}
        onCancel={CloseModalRemove}
        modalBody={
          <p className="text-center">
            Are you sure you want to delete this task?
          </p>
        }
      />

      {/* Edit Budget Modal */}
      <ActionModal
        show={showModalEditBudget}
        title={`Edit Budget - BD${String(budgetEdit.budget_id).padStart(
          3,
          "0"
        )}`}
        size="lg"
        modalBody={
          <EditBudget
            editData={budgetEdit}
            showToast={showToast}
            CloseModalEdit={CloseModalEditBudget}
            refreshProjectData={refreshProjectData}
            setToast={setToast}
          />
        }
      />

      {/* Task Allocation Modal */}
      {showModalTAllocation && (
        <TaskAllocationModal
          update={update}
          setUpdate={setUpdate}
          setTaskAllocationModel={handleCloseModalAllocation}
          taskAssign={taskAssign}
        />
      )}
    </div>
  );
}

export default Task;
